import background from '../../assets/img/fondo.jpg'
import backgroundBusiness from '../../assets/img/fondo2.jpg'
import logo from "../../assets/img/advise_consultore_logo-removebg-preview.png"
import monitor from "../../assets/img/monitor-sigger360.png"
import "../../assets/styles/paneles.css"
import { PanelesEnum } from '../../enums/PanelesEnum'
import { useEffect, useState } from 'react'

export default function PanelesBase(props){

    const [bkgImage, setBkgImage] = useState(background)

    const handleScroll = () => {
        const targetDiv = document.getElementById('service-card-4');
        if(!targetDiv.getBoundingClientRect()) return
        
        const targetDivTop = targetDiv.getBoundingClientRect().top;
        setBkgImage(targetDivTop > 0 ? background : backgroundBusiness)
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
    
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return(
        <div className="flex flex-column bg-gradient-to-r from-purple-600 to-blue-600 text-white overflow-hidden"
        style={{minHeight: "100vh", margin: props.isLargeScreen ? "30px 60px" : "30px 0px"}}>
            <div className="fixed inset-0 paneles-bkg-animation">
                <img className="w-full min-h-full object-cover" 
                src={bkgImage} alt="Background" />
                <div className="fixed inset-0 bg-black opacity-30"></div>
            </div>
            <div className='relative z-10 flex flex-col'>
                <div className='logo-paneles-component' style={{width: "fit-content"}}>
                    <a href='/'>
                        <img src={logo} alt="AdviseLogo" className='advise-logo paneles-component-animation'/>
                    </a>
                </div>
                <div className='paneles-title-container'>
                    <div className={props.isLargeScreen ? 'paneles-title' : 'paneles-title-movil'}>
                        <h1 className='paneles-title-label paneles-component-animation'
                        style={{fontSize: props.isLargeScreen ? "96px" : "80px",
                                textAlign: props.isLargeScreen ? "justify" : "center"}}
                                >{PanelesEnum.PRODUCT_TITLE}</h1>
                        <p className='paneles-title-description paneles-component-animation'
                            style={{textAlign: props.isLargeScreen ? "justify" : "center"}}
                            >{PanelesEnum.PRODUCT_DESCRIPTION}</p>
                    </div>
                    <div className='paneles-title-enviorments'>
                        <img src={monitor} alt="MonitorSigger" className='paneles-monitor paneles-component-animation'/>
                    </div>
                </div>
            </div>   
        </div>     
    )
}